module.exports = __webpack_public_path__ + "static/media/jackie.16feb7d2.jpg";